import Vue from "vue";
import VueRouter from "vue-router";
import Series from "../components/Series";
import DialogWrapper from "../views/DialogWrapper";
import series from "../assets/series.json";
import NotFound from "../components/NotFound";
import store from "../store";
import Gallery from "../components/Gallery";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Series,
    name: "home"
  },
  {
    path: "/artists/:slug",
    component: Gallery,
    name: "artist",
    beforeEnter(to, from, next) {
      try {
        const artist = store.getters.getSeriesByArtistSlug(to.params.slug);
        if (_.isNil(artist)) {
          next({ name: "notFound", params: { "0": to.path } });
        } else {
          next();
        }
      } catch (e) {
        console.log(e);
      }
    },
    children: [
      {
        path: "/artists/:slug/images/:id",
        name: "image",
        component: DialogWrapper,
        beforeEnter(to, from, next) {
          try {
            const photo = store.getters.getPhotoById(to.params.id);
            if (_.isNil(photo)) {
              next({ name: "notFound", params: { "0": to.path } });
            } else {
              next();
            }
          } catch (e) {
            console.log(e);
          }
        }
      }
    ]
  },
  { path: "*", name: "notFound", component: NotFound }
];

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});
router.beforeEach((to, from, next) => {
  if (store.state.series.length === 0) {
    store.dispatch("setSeries", series);
  }
  next();
});
export default router;
